import { Component, Inject, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '../../Common/modal-window/modal-window.service';
import { ModalWindowBaseComponent } from '../../Common/modal-window/modal-window-base.component';
import { PasarelaPagoService } from '../../Common/pasarela-pago.service';
import { InscripcionesService } from '../../Common/inscripciones.service';
import { SHARED_IMPORTS, SHARED_DECLARATIONS } from '../../Common/shared.config';
import { ModalWindowService } from '../../Common/modal-window/modal-window.service';

interface responsePay {
    datos: {
        url: string;
        datosTPV: {
            Ds_SignatureVersion: string;
            Ds_MerchantParameters: string;
            Ds_Signature: string;
        };
    };
    error: {
        codigo: string;
        texto: string;
    };
}

@Component({
    selector: 'app-dialog-pasarela-pago',
    templateUrl: './dialog-pasarela-pago.component.html',
    styleUrls: ['./dialog-pasarela-pago.component.scss'],
    standalone: true,
    imports: [...SHARED_IMPORTS, ...SHARED_DECLARATIONS]
})
export class DialogPasarelaPagoComponent extends ModalWindowBaseComponent implements OnInit {
    private _PasarelaPagoS: PasarelaPagoService = inject(PasarelaPagoService);
    private _InscripcionesS: InscripcionesService = inject(InscripcionesService);
    private _modalWindowS: ModalWindowService = inject(ModalWindowService);
    //   public moda_window_ref: MatDialogRef<DialogPasarelaPagoComponent>,
    public data: any = inject(MAT_DIALOG_DATA);
    public sending_data = false;
    public tpv_url = '';
    public datos_pago_TPV = {
        Ds_SignatureVersion: '',
        Ds_MerchantParameters: '',
        Ds_Signature: '',
    };
    // ===========================================================================
    // ---------------------------------------------------------------------------
    // constructor(

    //     @Inject(MAT_DIALOG_DATA) public data: any
    // ) {
    //     super();
    // }

    ngOnInit(): void {

        this.sending_data = true;
        this._PasarelaPagoS.getInfoTPV(this.data.importe).subscribe({
            next: (r: any) => this._onGetTpvData(r),
            error: (r: any) => this._onGetTpvDataError(r)
        });

    }

    // ===========================================================================
    // ---------------------------------------------------------------------------
    private _onGetTpvData_orig(r: any): void {
        this.sending_data = false;
        if (r.error.codigo) {
            console.error('Error llamando al TPV: \n' + r.error.texto);
            this._onGetTpvDataError(r.error.texto);
            return
        } 
        this.tpv_url = r.datos.url;
        this.datos_pago_TPV.Ds_SignatureVersion = r.datos.datosTPV.Ds_SignatureVersion;
        this.datos_pago_TPV.Ds_MerchantParameters = r.datos.datosTPV.Ds_MerchantParameters;
        this.datos_pago_TPV.Ds_Signature = r.datos.datosTPV.Ds_Signature;

        const form = <any>document.querySelector('[name="frmTPV"]');
        setTimeout(() => {
            form.submit();
            console.log('GGGGGGGGGGGGGGGGG ========>', this._InscripcionesS.dataIdStored);
            // alert('Aqui el submit para ir a la pasarela de pago');
        }, 250);

        // console.log('TPVdata: ', r);

    }

    // ---------------------------------------------------------------------------
    private _onGetTpvData(r: responsePay): void {
        this.sending_data = false;
        
        if (r.error.codigo) {
            console.error('Error llamando al TPV: \n' + r.error.texto);
            this._onGetTpvDataError(r.error);
            return;
        } 

        this.tpv_url = r.datos.url;
        this.datos_pago_TPV.Ds_SignatureVersion = r.datos.datosTPV.Ds_SignatureVersion;
        this.datos_pago_TPV.Ds_MerchantParameters = r.datos.datosTPV.Ds_MerchantParameters;
        this.datos_pago_TPV.Ds_Signature = r.datos.datosTPV.Ds_Signature;

        // Ejecutamos la redirección programática
        this._enviarTPVProgramaticamente();
    }

    // ---------------------------------------------------------------------------
    private _onGetTpvDataError(e: responsePay['error']): void {

        this.sending_data = false;
        console.error('Error obteniendo los datos del TPV\n' + e);
        this.close();   // Cerrar dialog conexión TPV
        setTimeout(() => {
            this._modalWindowS.showMessageError('Error obteniendo los datos del TPV\n' + e).subscribe();
            // this.close();
        }, 500);

    }

    // ---------------------------------------------------------------------------
    private _enviarTPVProgramaticamente(): void {
        // Creamos el elemento <form> en la memoria del navegador
        const formVirtual = document.createElement('form');
        formVirtual.method = 'POST';
        
        // Aquí se asigna la URL que hemos leído del input de la página
        formVirtual.action = this.tpv_url; 

        // Creamos e insertamos cada <input type="hidden">
        Object.entries(this.datos_pago_TPV).forEach(([key, value]) => {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.value = value;
            formVirtual.appendChild(input);
        });

        // Añadimos el formulario al documento para que sea válido para el navegador
        document.body.appendChild(formVirtual);
            
        // Hacemos el submit inmediato
        setTimeout(() => {
            formVirtual.submit();
            // Limpieza por si acaso, aunque la página ya va a cambiar
            document.body.removeChild(formVirtual); 
        }, 300);
    }

}
